var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfoIc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard--\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Updated_2020_07_21_info_tips_v2",
    transform: "translate(-1387.000000, -120.000000)",
    fill: "#3695FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(253.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(397.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747,14 C741.48,14 737,18.48 737,24 C737,29.52 741.48,34 747,34 C752.52,34 757,29.52 757,24 C757,18.48 752.52,14 747,14 Z M748,29 L746,29 L746,23 L748,23 L748,29 Z M748,21 L746,21 L746,19 L748,19 L748,21 Z",
    id: "Shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Info_ic.c798fc1c.svg";
export { ForwardRef as ReactComponent };